import { useTranslation } from 'react-i18next';

import { TTableColumn } from '@treezor/design-system';

import { useAppSelector } from '@/hooks/redux-helpers';
import { TDashboardUsersRowType } from '@/features/dashboard-users/store/support-user.model';

export function useDashboardUserTableHeaders(isActiveDashboardUserDisplayed: boolean = true) {
  const { t } = useTranslation();
  const is2FAEnabled = useAppSelector((state) => !!state.dashboardConfig.config.settings['2fa']);

  let headers: TTableColumn<TDashboardUsersRowType>[] = [
    {
      label: '',
      name: 'reviewStatus',
      field: 'reviewStatus',
    },
    {
      label: t('pages.administration.supportsUsers.table.username'),
      name: 'username',
      field: 'username',
    },
    {
      label: t('pages.administration.supportsUsers.table.role'),
      name: 'role',
      field: 'role',
    },
    isActiveDashboardUserDisplayed
      ? {
          label: t('pages.administration.supportsUsers.table.status.header'),
          name: 'status',
          field: 'status',
        }
      : {
          label: t('pages.administration.supportsUsers.table.suspendedOn'),
          name: 'suspensionDate',
          field: 'suspensionDate',
        },
  ];

  if (is2FAEnabled) {
    headers = [
      ...headers,
      {
        label: t('pages.administration.supportsUsers.table.status.2FA.header'),
        name: '2fa',
        field: '2fa',
      },
    ];
  }

  headers = [
    ...headers,
    {
      label: t('pages.administration.supportsUsers.table.status.lastActive'),
      name: 'lastactive',
      field: 'lastactive',
    },
    {
      label: t('pages.administration.supportsUsers.table.status.adhesion'),
      name: 'adhesion',
      field: 'adhesion',
    },
    {
      label: '',
      name: 'actions',
      field: 'actions',
    },
  ];
  return headers;
}
